import {
    UPDATE_RECIPE,
    UPDATE_RECIPE_FAILED,
    RESET_FORMS
} from '../actions/types'

const initialState = {}

const updateRecipeReducer = (state = initialState, action) => {
    switch(action.type){
        case UPDATE_RECIPE:
            return {
                details: action.payload,
                success: 'Recipe updated successfully',
            }
        case UPDATE_RECIPE_FAILED:
            return {
                ...state,
                errors: action.payload,
                success: null
            }
        case RESET_FORMS:
            return initialState
        default:
            return state
    }
}

export default updateRecipeReducer